/**
 * 商品検索用VOクラス
 *
 * @export CandidateGoodsSearchConditionModel
 * @class CandidateGoodsSearchConditionModel
 */
export class CandidateGoodsSearchConditionModel {

  public pcode: string;                                                         // Ｐコード
  public itemCode: string;                                                      // アイテムコード
  public ebaseSpecCode: string;                                                 // 仕様書コード
  public dataType: string;                                                      // データ種別
  public janCode: string;                                                       // JANコード
  public makerName: string;                                                     // メーカ名
  public guideGoodsNameList: Array<any> = new Array<any>();                     // 商品案内用商品名
  public guideStandardNameList: Array<any> = new Array<any>();                  // 商品案内用規格名
  public tagIdList: Array<string> = new Array<string>();                        // タグ
  public tagSearchType: string;                                                 // タグ検索方法
  public goodsMarkList: Array<string> = new Array<string>();                    // 商品マーク
  public goodsMarkSearchType: string;                                           // 商品マーク検索方法
  public dutiesFormWeekly: boolean = <boolean>false;                            // 業態区分（ウィークリー）
  public dutiesFormDailyList: Array<any> = new Array<any>();                    // 業態区分（デイリー）リスト
  public dutiesFormSpot: boolean = <boolean>false;                              // 業態区分（スポット）
  public ordrClientCode: string;                                                // 発注先コード
  public ordrClientKanji: string;                                               // 発注先名称
  public payeeClientCode: string;                                               // 支払先コード
  public payeeClientKanji: string;                                              // 支払先名称
  public classCode: string;                                                     // 部門コード
  public middleClassCode: string;                                               // 中分類コード
  public smallClassCode: string;                                                // 小分類コード
  public registDateFrom: string;                                                // 商品マスタ登録日From
  public registDateTo: string;                                                  // 商品マスタ登録日To
  public updateDateFrom: string;                                                // 商品マスタ更新日From
  public updateDateTo: string;                                                  // 商品マスタ更新日To
  public coopCodeList: Array<any> = new Array<any>();                           // 生協コード
  public admitStatus: string;                                                   // 登録レベル
  public buyerCode: string;                                                     // バイヤーコード
  public pcodeList: Array<any> = new Array<any>();                              // Ｐコードリスト
  public itemCodeList: Array<any> = new Array<any>();                           // アイテムコードリスト
  public goodsDiv: string = <string>'';                                         // 商品区分(空文字:全ての商品、1:ダミー商品)
  public dataKbnFlg: boolean = <boolean>false;                                  // 取扱終了商品を含む  

  // その他
  public pageNo = Number(0);                                            // ページ番号
  public sortKey: string = <string>'';                                          // ソートキー
  public orderKey: string = <string>'';                                         // 降順または昇順
  public goodsInfoOutDiv: string = <string>'0';                                 // 商品情報出力先区分(0:候補リスト画面、1:商品マスタ画面)
}
